import { createApiConstants } from '@saucelabs/sl-util-redux';

export const NAMESPACE = 'user-concurrency';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const GET_USER_ACTIVITY = createApiNamespacedConstants('get_user_activity');
export const GET_ORGANIZATION_ACTIVITY = createApiNamespacedConstants('get_organization_activity');
export const GET_TEAMS_ACTIVITY = createApiNamespacedConstants('get_teams_activity');
export const GET_GROUPS_ACTIVITY = createApiNamespacedConstants('get_groups_activity');

export const FETCH_USERS_ACTIVITY_COMPLETE = `${NAMESPACE}/FETCH_USERS_ACTIVITY_COMPLETE`;
export const CLEAN_UP = `${NAMESPACE}/CLEAN_UP`;
